export default class TgapExclureController {
    static $inject = ['$scope', '$stateParams', 'TgapExclureCommunicationService', 'TgapExclureService', 'notification', '$uibModal', 'SitesService'];

    constructor($scope, $stateParams, TgapExclureCommunicationService, TgapExclureService, notification, $uibModal, SitesService) {
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.TgapExclureCommunicationService = TgapExclureCommunicationService;
        this.TgapExclureService = TgapExclureService;
        this.notification = notification;
        this.$uibModal = $uibModal;
        this.SitesService = SitesService;
    }

    async $onInit() {
        console.log('🔥 - TgapExclureController - $onInit - this.idClient:', this.idClient);
        console.log('🔥 - TgapExclureController - $onInit - this.idChantier:', this.idChantier);
        this.isAllExclure = false;
        this.unregister = this.$scope.$watch(
            () => this.isOpen,
            async () => {
                if (this.isOpen && !this.tgapExclures) {
                    await this.loadTgapExclure();
                }
            },
            true
        );
        this.hasUserAccess = await this.SitesService.checkProfilRights(!!this?.idClient, 'siteclient');
    }

    $onDestroy() {
        this.unregister();
    }

    async loadTgapExclure() {
        console.log('🔥 - TgapExclureController - loadTgapExclure - idClient:', this.idClient, '/ idChantier:', this.idChantier);
        if (this.idClient) {
            this.startLoading();
            try {
                this.tgapExclures = await this.TgapExclureService.getTgapExclure(this.idClient, this.idChantier);
                console.log('🔥 - TgapExclureController - loadTgapExclure - résultat:', this.tgapExclures);
                if (this.tgapExclures.find((x) => x.isExclure)) {
                    this.isAllExclure = true;
                } else {
                    this.isAllExclure = false;
                }
            } catch (err) {
                if (err.data) {
                    this.notification.error(err.data);
                } else {
                    throw err;
                }
            }
            this.stopLoading();
        }
    }

    async updateTgapExclure(tgapExclure) {
        console.log(
            '🔥 - TgapExclureController - updateTgapExclure - isBloque:',
            tgapExclure.isBloque,
            '/ idTgapExclure:',
            tgapExclure.idTgapExclure,
            '/ isExclure:',
            tgapExclure.isExclure
        );
        if (!tgapExclure.isBloque) {
            if (tgapExclure.idTgapExclure) {
                console.log('🔥 - TgapExclureController - updateTgapExclure - DELETE id:', tgapExclure.idTgapExclure);
                this.TgapExclureService.deleteTgapExclureById(tgapExclure.idTgapExclure);
            } else {
                console.log('🔥 - TgapExclureController - updateTgapExclure - CREATE idClient:', this.idClient, '/ idChantier:', this.idChantier);
                tgapExclure.idClient = this.idClient;
                tgapExclure.idChantier = this.idChantier;
                this.TgapExclureService.createTgapExclure(tgapExclure);
            }
        } else {
            console.warn('🔥 - TgapExclureController - updateTgapExclure - BLOQUÉ (isBloque=true), aucune action');
        }
    }

    async changeExclure(tgapExclure) {
        console.log('🔥 - TgapExclureController - changeExclure - tgapExclure:', tgapExclure);
        await this.updateTgapExclure(tgapExclure);
        await this.loadTgapExclure();
    }

    async changeAllExclure() {
        this.startLoading();
        console.log('🔥 - TgapExclureController - changeAllExclure - isAllExclure:', this.isAllExclure);
        const tgapExclureSelecteds = this.tgapExclures.filter((x) => x.isExclure != this.isAllExclure);
        tgapExclureSelecteds.forEach(async function (element) {
            await this.updateTgapExclure(element);
        }, this);
        this.stopLoading();
        await this.loadTgapExclure();
    }

    startLoading() {
        this.loading = true;
    }

    stopLoading() {
        this.loading = false;
    }
}
